import moment from 'moment';
import {dateFormatter} from 'components/Inputs/Dates/utils/dateformatter';
import getLocaleParams from 'utils/calendar/calendarLocaleParams';

import _ from 'lodash';
_.noConflict();


function wrap (m) {
  return _.extend(m, {
    formatDateApi () {
      return this.format(dateFormatter.momentDateApiFormat());
    },
    firstDayOfWeek () {
      return moment().lang()._week.dow;
    }
  });
}


const wrapper = function () {
  moment.lang(getLocaleParams('locale'));
  return wrap(moment.apply(null, arguments));
};
Object.setPrototypeOf(wrapper, moment);

export {wrapper as momentWrapper};
